import React from "react";

const Card = ({ image, title, description, overlayColor }) => {
  return (
    <div className="product-card1 opacity-0 transform translate-y-10">
      {/* Image with overlay */}
      <div className="relative w-full overflow-hidden">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        {overlayColor && (
          <div
            className="absolute inset-0"
            style={{ backgroundColor: overlayColor, mixBlendMode: "multiply" }}
          ></div>
        )}
      </div>

      {/* Title Section */}
      <div className="mt-4 flex items-center gap-2 text-2xl font-bold">
        <span>{title}</span>
      </div>

      {/* Description */}
      <p className="mt-2 text-gray-600 text-left text-xl">{description}</p>
    </div>
  );
};

export default Card;